export default __webpack_public_path__ + "static/media/toogle_sidebar_on.84ff753e.svg";